import axiosInstance from ".";

export const create = (subscription) =>
  axiosInstance.post(`/v1/subscriptions`,subscription);

export const verify = (details) =>
  axiosInstance.post(`/v1/subscriptions/verify-payment`,details);  

export const fetchSubscription = () =>
  axiosInstance.get(`/v1/subscriptions/user`);  

export const fetchFreePeriodEligibility = () =>
  axiosInstance.get(`/v1/subscriptions/free-period-eligibility`);

export const changePlan = (planId) =>
  axiosInstance.post(`/v1/subscriptions/change-plan`,{planId});  

export const cancel = (subscription) =>
  axiosInstance.post(`/v1/subscriptions/cancel`,subscription);

  export const updatChangePlanStatus = (updateSubscription ) =>
   axiosInstance.post(`/v1/subscriptions/change-plan/status`,updateSubscription);   